import * as React from "react";

import styled from "styled-components";
import { useGlobalUserMethods, useGlobalUserState } from "~/state";

interface ModuleHeaderProps {
  currentPage: number;
  totalPages: number;
}

export const ModuleHeader = React.forwardRef<HTMLElement, ModuleHeaderProps>(
  ({ currentPage, totalPages }, ref) => {
    const modules = Array(totalPages).fill(0);

    const { startedModules } = useGlobalUserState();
    const { goToModule } = useGlobalUserMethods();

    return (
      <header
        css={`
          margin-top: -2rem;
          margin-left: -2rem;
          margin-right: -2rem;
        `}
        className="position-relative app-header bg-light p-3 mb-5"
        ref={ref}
      >
        <div className="d-flex align-items-center p-3">
          <strong className="h3 text-warning mb-0">Module {currentPage}</strong>
        </div>

        <ModuleMap>
          {modules.map((_, idx) => (
            <StyledStep
              key={idx}
              active={idx > currentPage - 1}
              type="button"
              onClick={(e) => {
                e.preventDefault();
                goToModule(idx + 1);
              }}
              disabled={!startedModules[idx + 1]}
            >
              <strong>{idx + 1}</strong>
            </StyledStep>
          ))}
        </ModuleMap>
      </header>
    );
  },
);

const ModuleMap = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
`;

export const StyledStep = styled.button<{ active: boolean }>`
  width: 2rem;
  height: 2rem;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${(p) => (p.active ? p.theme.gray500 : p.theme.warning)};
  border-radius: 50%;
  margin: 0 calc(1.25rem - 1px);
  color: white;
  border: 0;

  &::before {
    content: "";
    position: absolute;
    width: 1.25rem;
    height: 10px;
    top: calc(50% - 5px);
    left: calc(-1.25rem + 1px);
    background: ${(p) => (p.active ? p.theme.gray500 : p.theme.warning)};
  }
  :first-of-type {
    margin-left: 0;
    &::before {
      content: none;
    }
  }

  &::after {
    content: "";
    position: absolute;
    width: 1.25rem;
    height: 10px;
    top: calc(50% - 5px);
    right: calc(-1.25rem + 1px);
    background: ${(p) => (p.active ? p.theme.gray500 : p.theme.warning)};
  }
  :last-of-type {
    margin-right: 0;
    &::after {
      content: none;
    }
  }
`;
